/*
 * Copyright (c) Nexign, JSC, 2019.
 */

/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.0.0
 * @since 1.0.1
 */

import styled from 'styled-components';

import { colors } from '../../../../theme';
import { IAttrStyled } from '../../../../types/globalTypes';
import * as skeleton from '../skeletonConfiguration';
import { ISkeletonStyled } from '../skeletonTypes';
import { LoaderAnimation } from './SkeletonStyled';

export const SkeletonParagraphStyled = styled(LoaderAnimation).attrs((props: IAttrStyled) => ({
    className: `skeleton__paragraph ${props.className}`,
}))<ISkeletonStyled>`
    width: ${skeleton.width};
    height: ${skeleton.height};
    animation-name: ${skeleton.animationName};
    animation-duration: ${skeleton.animationDuration};
    background: ${colors.skeletonBgLoader};
`;
